import { render } from "./tagBase.vue?vue&type=template&id=c78ae494&scoped=true"
import script from "./tagBase.vue?vue&type=script&lang=js"
export * from "./tagBase.vue?vue&type=script&lang=js"

import "./tagBase.vue?vue&type=style&index=0&id=c78ae494&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c78ae494"]])

export default __exports__